/**
 * Redux file for getting/setting Expense Inventory list filters
 * @module src/store/ducks/expenseInventoryFilters
 */
/* eslint-disable import/no-cycle */
import { ActionType, State } from '.';

// action
const SET_EXPENSE_INVENTORY_FILTERS = 'SET_EXPENSE_INVENTORY_FILTERS';
const CLEAR_EXPENSE_INVENTORY_FILTERS = 'CLEAR_EXPENSE_INVENTORY_FILTERS';

interface SetExpenseInventoryFiltersActionType {
  payload: string | null;
  type: typeof SET_EXPENSE_INVENTORY_FILTERS;
}

interface ClearExpenseInventoryFiltersActionType {
  type: typeof CLEAR_EXPENSE_INVENTORY_FILTERS;
}

/** expenseInventoryFilters action type */

export type ExpenseInventoryFilterActionType =
  | SetExpenseInventoryFiltersActionType
  | ClearExpenseInventoryFiltersActionType;

/** set expenseInventoryFilters action creator */

export const setExpenseInventoryFilters = (
  state: string | null
): ExpenseInventoryFilterActionType => {
  return {
    payload: state,
    type: SET_EXPENSE_INVENTORY_FILTERS,
  };
};

/** clear expenseInventoryFilters action creator */

export const clearExpenseInventoryFilters = (): ExpenseInventoryFilterActionType => {
  return {
    type: CLEAR_EXPENSE_INVENTORY_FILTERS,
  };
};

/** expenseInventoryFilters state type */

export type ExpenseInventoryFilterState = string | null;

/** expenseInventoryFilters reducer */

export default (
  state: ExpenseInventoryFilterState = null,
  action: ActionType
): ExpenseInventoryFilterState => {
  switch (action.type) {
    case SET_EXPENSE_INVENTORY_FILTERS: {
      return action.payload;
    }
    case CLEAR_EXPENSE_INVENTORY_FILTERS: {
      return null;
    }
    default:
      return state;
  }
};

/** expenseInventoryFilters selector */

export const getExpenseInventoryFilters = (state: State): ExpenseInventoryFilterState =>
  state.expenseInventoryFilters;
